export const API_TOKEN = {
  leadLovers: 'BEF0D70F0D5F4B6B838C479C035857C8'
}